export default __webpack_public_path__ + "static/media/player-leah-colour-mob.b14312e7.png";